export default __webpack_public_path__ + "images/HO.cf52bdb.png";